// extracted by mini-css-extract-plugin
export default {"root":"lOS9Y","link":"yy6Hd"};